import React from 'react';
import TicketsView from '../../../components/tickets/TicketsView';

export default function TicketsManagement() {
  return <TicketsView />;
}


